import { render, staticRenderFns } from "./RestrictProposalModal.vue?vue&type=template&id=2076d439"
import script from "./RestrictProposalModal.vue?vue&type=script&lang=js"
export * from "./RestrictProposalModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports